/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedItemTrackingProvider_viewer = {
    readonly regionalInfo?: ReadonlyArray<{
        readonly regionsByZipCode: ReadonlyArray<{
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $refType": "SbSharedItemTrackingProvider_viewer";
};
export type SbSharedItemTrackingProvider_viewer$data = SbSharedItemTrackingProvider_viewer;
export type SbSharedItemTrackingProvider_viewer$key = {
    readonly " $data"?: SbSharedItemTrackingProvider_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedItemTrackingProvider_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedItemTrackingProvider_viewer",
  "selections": [
    {
      "condition": "fetchRegionalInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "zipCode",
              "variableName": "userZipCode"
            }
          ],
          "concreteType": "RegionalInfo",
          "kind": "LinkedField",
          "name": "regionalInfo",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RegionsByZipCode",
              "kind": "LinkedField",
              "name": "regionsByZipCode",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '8f6b57b3c8e071c3e629c5e09591e0ac';
export default node;
